<a *ngIf="social" class="text-white" href="{{social.field_link_social[0].value}}" target="_blank">
    <ng-container [ngSwitch]="social.field_nome_social[0].value">
        <i *ngSwitchCase="'Youtube'" class="fa-brands fa-youtube-square"></i>
        <i *ngSwitchCase="'Twitter'" class="fa-brands fa-twitter-square"></i>
        <i *ngSwitchCase="'Facebook'" class="fa-brands fa-facebook-square"></i>
    </ng-container>
</a>
